import React from 'react';
import ServiceDescriptionSection from '../../components/ServiceDescriptionSection';
import ServiceLegalRepresentationRationale from '../../components/ServiceLegalRepresentationRationale';
import ServiceContactUsSection from '../../components/ServiceContactUs';

const Divorce = () => {
  return (
    <div className='servicePage'>
      <div className='servicePageContent'>
        <div className="header">Divorce</div>
        <div className="body">
          <ServiceDescriptionSection
            content={
              <div>
                <div>Divorce is the legal dissolution of a marriage, allowing both parties to remarry in the future. Key points about divorce in Australia include:</div>
                <ul>
                  <li><strong>Grounds for Divorce:</strong> The only ground for divorce in Australia is the irretrievable breakdown of the marriage, which is evidenced by a separation period of at least 12 months.</li>
                  <li><strong>Filing for Divorce:</strong> Either spouse can file for divorce in the Federal Circuit Court. The process involves submitting an application, attending a court hearing (if required), and serving the application on the other spouse.</li>
                  <li><strong>Considerations:</strong> The court may consider various factors, including the welfare of any children and the financial circumstances of both parties, although it does not require a reason for the breakdown of the marriage.</li>
                </ul>
              </div>
            }
          />
          <ServiceLegalRepresentationRationale
            header="Legal Representation in Family Law Matters"
            content="Navigating family law matters can be complex and emotionally challenging. Seeking legal advice is crucial to ensure that your rights are protected and that you understand your options."
          />
          <ServiceContactUsSection
            header="Contact Us for Legal Assistance"
            content="If you require legal assistance with family law matters dedicated team is here to help. We provide expert advice and representation tailored to your unique circumstances, ensuring the best possible outcome for you and your family."
          />
        </div>
      </div>
    </div>
  );
};

export default Divorce;